import styled from 'styled-components'

export const CatalogItemTagIconStyled = styled.span<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(props) => props.theme.typography.pxToRem(props.$size)};
  height: ${(props) => props.theme.typography.pxToRem(props.$size)};
  line-height: 0;
`
